/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 15H18L12 9H6V15ZM6 15L12 21V15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 9H18V3H6L12 9ZM12 9L18 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M6 3H18V9H12L18 15H12V21L6 15V9H12L6 3Z"
				fill="currentColor"
			/>
			<path
				d="M12 9H18V3H6L12 9ZM12 9H6V15M12 9L18 15H6M6 15L12 21V15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M5.55502 3.61569C5.12664 3.18731 4.91245 2.97312 4.89798 2.78923C4.88542 2.62967 4.95001 2.47374 5.07171 2.3698C5.21198 2.25 5.51489 2.25 6.1207 2.25H16.35C17.1901 2.25 17.6101 2.25 17.931 2.41349C18.2132 2.5573 18.4427 2.78677 18.5865 3.06901C18.75 3.38988 18.75 3.80992 18.75 4.65V7.35C18.75 8.19008 18.75 8.61012 18.5865 8.93099C18.4427 9.21323 18.2132 9.4427 17.931 9.58651C17.6101 9.75 17.1901 9.75 16.35 9.75H15.2249L14.1308 8.65589C13.6119 8.13703 13.3525 7.8776 13.0497 7.69208C12.7813 7.52759 12.4887 7.40638 12.1826 7.33289C11.8373 7.25 11.4704 7.25 10.7366 7.25H9.18933L5.55502 3.61569Z"
				fill="currentColor"
			/>
			<path
				d="M11.3843 21.445C11.8127 21.8734 12.0269 22.0875 12.2108 22.102C12.3703 22.1146 12.5262 22.05 12.6302 21.9283C12.75 21.788 12.75 21.4851 12.75 20.8793V16.75H6.68933L11.3843 21.445Z"
				fill="currentColor"
			/>
			<path
				d="M5.25 10.65C5.25 9.80992 5.25 9.38988 5.41349 9.06901C5.5573 8.78677 5.78677 8.5573 6.06901 8.41349C6.38988 8.25 6.80992 8.25 7.65 8.25H10.9852C11.4744 8.25 11.7189 8.25 11.9491 8.30526C12.1532 8.35425 12.3483 8.43506 12.5272 8.54472C12.7291 8.6684 12.902 8.84135 13.2479 9.18726L18.445 14.3843C18.8734 14.8127 19.0875 15.0269 19.102 15.2108C19.1146 15.3703 19.05 15.5263 18.9283 15.6302C18.788 15.75 18.4851 15.75 17.8793 15.75H5.68934C5.40804 15.4687 5.25 15.0872 5.25 14.6893V10.65Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 9H18V3H6L12 9ZM12 9L18 15H6M6 15V9H8.5M6 15L12 21V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 9H18V3H6L12 9ZM12 9H6V15M12 9L18 15H6M6 15L12 21V15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g opacity="0.32">
				<path
					d="M11.3843 21.445C11.8127 21.8734 12.0269 22.0875 12.2108 22.102C12.3703 22.1146 12.5262 22.05 12.6302 21.9283C12.75 21.788 12.75 21.4851 12.75 20.8793V15.75H5.68933L11.3843 21.445Z"
					fill="currentColor"
				/>
				<path
					d="M5.55502 3.61569C5.12664 3.18731 4.91245 2.97312 4.89798 2.78923C4.88542 2.62967 4.95001 2.47374 5.07171 2.3698C5.21198 2.25 5.51489 2.25 6.1207 2.25H16.35C17.1901 2.25 17.6101 2.25 17.931 2.41349C18.2132 2.5573 18.4427 2.78677 18.5865 3.06901C18.75 3.38988 18.75 3.80992 18.75 4.65V7.35C18.75 8.19008 18.75 8.61012 18.5865 8.93099C18.4427 9.21323 18.2132 9.4427 17.931 9.58651C17.6101 9.75 17.1901 9.75 16.35 9.75H13.8107L13.2479 9.18726C12.902 8.84135 12.7291 8.6684 12.5272 8.54472C12.3483 8.43506 12.1532 8.35425 11.9491 8.30526C11.7189 8.25 11.4743 8.25 10.9852 8.25H10.1893L5.55502 3.61569Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M10.1893 8.25H7.65C6.80992 8.25 6.38988 8.25 6.06901 8.41349C5.78677 8.5573 5.5573 8.78677 5.41349 9.06901C5.25 9.38988 5.25 9.80992 5.25 10.65V14.6893C5.25 15.0872 5.40804 15.4687 5.68934 15.75H17.6893H17.8793C18.4851 15.75 18.788 15.75 18.9283 15.6302C19.05 15.5263 19.1146 15.3703 19.102 15.2108C19.0875 15.0269 18.8734 14.8127 18.445 14.3843L13.8107 9.75L13.2479 9.18726L13.2479 9.18726C12.902 8.84135 12.7291 8.6684 12.5272 8.54472C12.3483 8.43506 12.1532 8.35425 11.9491 8.30526C11.7189 8.25 11.4744 8.25 10.9852 8.25H10.1893Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
